module.exports = {
    apiKey: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpbmZvIjoic2VjcmV0IGluZm9ybWF0aW9uIGZvciBUaWxsaU1MIEFQSSBLZXkiLCJmcm9tIjoiVGlsbGlNTCJ9.dcMpiHW3P6x7eiba0tB4HQ96Y7hi_LQ22HLCf8QjxHk",
    isLocal: false,
}
